import { ContentState } from "draft-js";
import { TextSection } from "@domain/lms/course/courseSection";
import { SectionController } from "@ui/pages/lms/courseEditorPage/courseEditorController/sectionController";

export class TextSectionController extends SectionController<TextSection> {
	setContent(content: ContentState): void {
		this.sectionUpdater((section) => ({ ...section, content }));
	}
}
